<template>
	<el-dialog title="回收站" :visible.sync="dialogVisible" width="47.7%" :before-close="handleClose" class="version-update"
	 :close-on-click-modal="false">
		<div >
			<div class="system-notice-div">
				<el-row >
					<el-col :span="12" class="system-title">升级提醒</el-col>
					<el-col :span="12" class="textR"><span @click.stop="handleClose" class="curpointer"><img src="../../../assets/img/gonggao/guanbi.png" alt=""></span></el-col>
				</el-row>
				<div class="system-content">
					<div>{{ messageInfo.content }}</div>
				</div>
				<div class="system-footer">
					<el-button class="close-btn" @click.stop="handleClose"><img src="../../../assets/img/gonggao/btn-guanbi.png" alt="">关闭</el-button>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {

		},
		data() {
			return {
				dialogVisible: false,
				verlist:[
					{id:'1',content:'新增专题创建规范'},
					{id:'2',content:'新增专题创建规范新增专题创建规范新增专题创建规范新增专题创建规范新增专题创建规范新增专题创建规范'},
					{id:'3',content:'新增专题创建规范'},
					{id:'4',content:'新增专题创建规范'},
					{id:'5',content:'新增专题创建规范'}
				],
				messageInfo:{}
			}
		},
		methods: {
			show(messageInfo) {
				this.messageInfo = messageInfo
				this.dialogVisible = true
			},
			handleClose(done) {
				this.dialogVisible = false
			},

			initPage() {

			},

		}
	};
</script>

<style lang="less">
	.version-update {
		.el-dialog{
			min-width:600px;
			max-width: 687px;
			border-radius: 10px;
			// width: 687px;
			// height: 598px;
			background-color: transparent;
			border: none;
		}

		.el-dialog__header{
			display: none;

		}
		.el-dialog__body {
			// width: 687px
			width: 100%;
			padding: 0px!important;
			height: 598px;
			background-image: url(../../../assets/img/gonggao/bigbg.png);
			background-repeat: no-repeat;
			background-position: 0px 0px;
			border-radius: 10px;
			//background-origin:padding-box;
			// background-size: cover;
			background-size:cover;
			background-clip:padding-box;
			background-color: transparent;
			border-color:transparent!important;
			box-sizing: border-box;
		}
		.system-notice-div{
			width: 100%;
			height: 100%;
			padding: 5px 5px 0px 5px;
			.system-title{
				height: 100px;
				font-family: MicrosoftYaHei;
					font-size: 26px;
					font-weight: normal;
					font-stretch: normal;
					letter-spacing: 0px;
					color: #ffffff;
					line-height: 100px;
					padding-left: 28px;

			}
			.system-content{
				height: 306px;
				padding: 40px 84px 0px 84px;
				font-family: MicrosoftYaHeiLight;
					font-size: 18px;
					font-weight: normal;
					font-stretch: normal;
					letter-spacing: 0px;
					color: #666666;
				line-height: 25px;
				white-space: pre-wrap;
					overflow: hidden;
			}
			.system-footer{
				height: 192px;
				text-align: center;
				padding: 86px 0px 0px 0px;
				.close-btn{
					width: 285px;
						height: 45px;
						//background-color: #2facff;
						background-color: transparent;
						border-radius: 22px;
						border: solid 2px #ffffff;
						padding: 0px;
						color:#fff;

				}
			}
		}


	}
</style>
